import { AsYouType, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import React, { ChangeEvent, FC, useState } from 'react';

export const AppDownloadSendMeLink: FC = () => {
  const [error, setError] = useState<string>();
  const [phone, setPhone] = useState<string>('');
  const [isSent, setIsSent] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const sendLink = async () => {
    setError(undefined);
    if (!isValidPhoneNumber(phone, 'US')) return setError('Invalid phone number');

    const parsed = parsePhoneNumber(phone, 'US');

    setLoading(true);
    setIsSent(false);

    try {
      await fetch(`${process.env.GATSBY_BASE_URL}/text-download-app-link`, {
        method: 'POST',
        headers: {
          'X-App-Id': 'CircleOf',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phone: parsed.number }),
      });
      setLoading(false);
      setIsSent(true);
    } catch (e: unknown) {
      setError((e as any).message);
      setLoading(false);
      setIsSent(false);
    }
  };

  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = e;

    setError(undefined);

    if (/(.?\d){4,}/.test(value)) {
      setPhone(new AsYouType('US').input(value));
      return;
    }

    setPhone(value);
  };

  return (
    <div>
      {!isSent && (
        <span className="text-dark-ocean-blue text-center md:text-left font-bold font-roboto block">
          Enter your phone number and we’ll text you a link to download the app.
        </span>
      )}
      {!!error && <span className="block text-xs font-medium text-red-700">{error}</span>}

      {isSent ? (
        <div>
          <p className="font-bold text-dark-ocean-blue font-raleway">Thank you for choosing CircleOf.</p>
          <p>We've sent you a link to download the app at your mobile</p>
        </div>
      ) : (
        <div className="flex flex-col md:flex-row items-center mt-2">
          <input
            disabled={loading}
            value={phone}
            onChange={handlePhoneChange}
            className={`w-full md:w-auto grow py-5 px-8 md:mr-2 border-b-2 font-medium font-roboto text-lg outline-none ${
              error ? 'border-b-red-500' : 'border-b-gray-300'
            }`}
            style={{ color: '#556F7C' }}
            type="text"
            placeholder="+1 (123) 123-1234"
          />
          <button
            disabled={loading}
            onClick={sendLink}
            type="submit"
            className="w-full md:w-auto mt-2 md:mt-0 bg-accent-green py-2 px-8 rounded-full font-bold text-white"
          >
            {loading ? 'Processing...' : 'Send Me the App'}
          </button>
        </div>
      )}
      <span
        style={{ color: 'rgba(5, 55, 80, .5)', fontSize: 10, lineHeight: '10px' }}
        className="text-center md:text-left block mt-2"
      >
        By providing your phone number, you agree to receive a one-time automated text message with a link to get the app.
        <br />
        Standard messaging rates may apply.
      </span>
    </div>
  );
};

export default AppDownloadSendMeLink;
